import * as React from 'react';
import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-dynamic-calltracking-component';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import ButtonPhone from '../button_phone';

interface IDynamicPhoneButtonProps {
  blockId?: number | null;
  defaultPhone: string;
  phoneAsLabel?: boolean;
  onClick(phone: string): void;
}

interface IDynamicPhoneButtonState {
  dynamicPhone: string | null | undefined;
}

export class DynamicPhoneButton extends React.Component<IDynamicPhoneButtonProps, IDynamicPhoneButtonState> {
  public state = {
    dynamicPhone: null,
  };

  public onClick = async () => {
    const { blockId, onClick } = this.props;

    if (blockId && typeof window !== 'undefined') {
      try {
        const { notFormattedPhone } = await handleDynamicCalltracking({
          blockId,
          platformType: EPlatformTypes.WebDesktop,
          pageType: EPageTypes.NewbuildingBlockOfferList,
          httpApi: getHttpApi(),
          logger: getLogger(),
          placeType: 'Open_jk_head_block',
        });

        this.setState({ dynamicPhone: notFormattedPhone });
      } catch (e) {}
    }

    onClick(this.props.defaultPhone);
  };

  public render() {
    const { phoneAsLabel, defaultPhone } = this.props;

    return (
      <ButtonPhone phone={this.state.dynamicPhone || defaultPhone} onClick={this.onClick} phoneAsLabel={phoneAsLabel} />
    );
  }
}
